import { useRef } from 'react';
import { observer } from 'mobx-react';
import FormCommon, { FormCommonInstance } from '@/components/FormCommon';
import { CheckboxItem, BaseItem } from '@/components/FormItem';
import { useTaskbar } from '@/store';
import TaskbarSelect from './TaskbarSelect';
import { $fm } from '@/Intl';

export default observer(() => {
  const formRef = useRef<FormCommonInstance>(null);
  const [taskbar, updateTaskbar, defaults] = useTaskbar();
  return (
    <FormCommon
      defaults={defaults}
      onUpdate={updateTaskbar}
      initialValues={taskbar}
      ref={formRef}
    >
      <CheckboxItem
        label={$fm('DISABLE_TASKBAR')}
        name='disable'
        onChange={(e) => {
          if (e.target.checked) {
            formRef.current?.updateValue({
              tasks: defaults.tasks,
            });
          }
        }}
      />

      <BaseItem
        label={null}
        name='tasks'
        depends={{
          disable: 0,
        }}
      >
        <TaskbarSelect defaultTasks={defaults.tasks} />
      </BaseItem>
    </FormCommon>
  );
});
